import React, { useEffect } from 'react';

import TimeframeField from 'projects/components/BriefFields/TimeframeField';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';

type Fields = React.ComponentProps<typeof TimeframeField>['form']['data'];

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
    };
}

const TimeAndBudgetPage: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    brief,
}) => {
    useEffect(() => {
        trackViewedBriefEvent({
            id: brief.id,
            page: 'TimeAndBudget',
        });
    }, []);

    return (
        <div className="content-setting">
            <TimeframeField form={form} />
        </div>
    );
};

export default TimeAndBudgetPage;
